import { Button, ButtonProps } from "@biblioteksentralen/react";
import { ChevronLeft, ChevronRight } from "react-feather";
import { LocalizedNextLink } from "./LocalizedNextLink";

type Props = ButtonProps & { url: string; title?: string; arrowLeft?: boolean };

const SeeAllButton = ({ url, title = "Vis alle", arrowLeft, ...buttonProps }: Props) => (
  <Button
    href={url}
    as={LocalizedNextLink}
    size="md"
    variant="link"
    rightIcon={arrowLeft ? undefined : <ChevronRight />}
    leftIcon={arrowLeft ? <ChevronLeft /> : undefined}
    color="currentColor"
    {...buttonProps}
  >
    {title}
  </Button>
);

export default SeeAllButton;
